import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Checkbox, FormControl, FormLabel, Grid, Input, List, ListItem, Typography } from '@mui/joy';
import { Save } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { post } from '../../../api/api';
import { CLayout } from '../../../components';
import { jwtDecode } from 'jwt-decode';
import { TitleContext } from '../../../components/Layout';
import { SCOPE_OPTIONS, abonnementSchema } from '../constants'; // chemin à adapter selon votre structure

export const VCreateAbonnement: React.FC = () => {
    const { setTitle } = useContext(TitleContext) || {};
    const [selectedScopes, setSelectedScopes] = useState<string[]>([]);

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const dataObj = Object.fromEntries(formData.entries());

        try {
            // Validation avec yup
            await abonnementSchema.validate(dataObj, { abortEarly: false });

            const payload = {
                ...dataObj,
                scopes: selectedScopes,
            };
            console.log(payload);
            await post({ url: 'subscription_plans', data: payload });
            Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: "L'abonnement a été créé avec succès.",
            }).then(() => {
                window.location.href = '/plans';
            });
        } catch (error: any) {
            if (error.name === 'ValidationError') {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur de validation',
                    text: error.errors.join(', '),
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de la création de l’abonnement.',
                });
            }
        }
    };

    const handleScopeChange = (scope: string) => {
        setSelectedScopes((prev) =>
            prev.includes(scope) ? prev.filter((s) => s !== scope) : [...prev, scope]
        );
    };

    useEffect(() => {
        const token = localStorage.getItem("token") || '';
        const decode: any = jwtDecode(token);
        if (!decode.roles.includes('ROLE_ADMIN')) {
            window.location.href = '/';
        }
        if (setTitle) {
            setTitle('Ajouter un abonnement');
        }
    }, [setTitle]);

    return (
        <CLayout>
            <section id="VCreateAbonnement">
                <form onSubmit={submit}>
                    <Grid container spacing={2}>
                        <Grid xs={12}>
                            <Card className="cards" sx={{ p: 3, mt: 3 }}>
                                <Grid container spacing={2}>
                                    <Grid xs={12}>
                                        <FormControl>
                                            <FormLabel>Nom</FormLabel>
                                            <Input name="name" placeholder="Nom de l'abonnement" />
                                        </FormControl>
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormControl>
                                            <FormLabel>Stripe ID</FormLabel>
                                            <Input name="stripe_plan_id" placeholder="Identifiant Stripe du plan" />
                                        </FormControl>
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormLabel>Scopes</FormLabel>
                                        <List>
                                            {SCOPE_OPTIONS.map((scope, key) => (
                                                <ListItem key={key}>
                                                    <Checkbox
                                                        value={scope.id}
                                                        label={scope.name}
                                                        checked={selectedScopes.includes(scope.id)}
                                                        onChange={() => handleScopeChange(scope.id)}
                                                    />
                                                    <Typography level="body-xs" sx={{ ml: 1 }}>
                                                        {scope.name}
                                                    </Typography>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Grid>

                                    <Grid xs={4} sx={{ ml: 'auto' }}>
                                        <Button type="submit" className="float-right">
                                            <Save sx={{ mr: 1 }} /> Enregistrer
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                </form>
            </section>
        </CLayout>
    );
};